/* ════════════ PIXEL SPEED STREAKS ════════════
   Horizontal pixel streaks tearing across the screen — the fastr page's
   counterpart to the home page starfield. Events in flight. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function streaks(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#streaks")!;
  const ctx = c.getContext("2d")!;
  const colors = ["#ffd84d", "#ffe89a", "#b89a2e", "#ff3b30", "#2bd9ff"];

  type Streak = {
    x: number;
    y: number;
    len: number; // streak length in px
    h: number; // thickness
    vx: number; // velocity
    col: string;
  };
  let streaks: Streak[] = [];

  const make = (anywhere = false): Streak => {
    const fast = Math.random() > 0.6;
    return {
      x: anywhere ? Math.random() * c.width : -48,
      y: (Math.random() * c.height) | 0,
      len: fast ? 18 + Math.random() * 30 : 8 + Math.random() * 14,
      h: Math.random() > 0.85 ? 2 : 1,
      vx: fast ? 7 + Math.random() * 8 : 2.5 + Math.random() * 3,
      col: colors[(Math.random() * colors.length) | 0]!,
    };
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(70, Math.floor((c.width * c.height) / 26000));
    streaks = Array.from({ length: count }, () => make(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const s of streaks) {
      // brighter head, fading tail: reads as motion even in a still frame
      ctx.globalAlpha = 0.5;
      ctx.fillStyle = s.col;
      ctx.fillRect((s.x - s.len) | 0, s.y, s.len, s.h);
      ctx.globalAlpha = 0.9;
      ctx.fillRect((s.x - 3) | 0, s.y, 3, s.h);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (const s of streaks) {
      s.x += s.vx;
      if (s.x - s.len > c.width + 8) Object.assign(s, make());
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(streaks);
